import { useEffect, useState } from "react";

import {  getMyNotificationsWithPagination } from "../../../services/Trainer/trainer";

const PAGE_LIMIT = 5;

const PaginatedNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [cachedPages, setCachedPages] = useState({});

  const fetchNotifications = async (page = 1) => {
    setLoading(true);

    // Return from cache if already fetched
    if (cachedPages[page]) {
      setNotifications(cachedPages[page]);
      setCurrentPage(page);
      setLoading(false);
      return;
    }

    try {
      const response = await getMyNotificationsWithPagination({ page, limit: PAGE_LIMIT });
      if (response?.success) {
        
        setNotifications(response.notifications);
        setCurrentPage(page);
        setTotalPages(response.totalPages || 1);

        // Cache the page
        setCachedPages((prev) => ({
          ...prev,
          [page]: response.notifications,
        }));
      } 
    } catch (err) {
      console.error(err);
    //   toast.error("Something went wrong while fetching notifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications(1);
  }, []);

  const getNotificationIcon = (message) => {
    if (message.includes("reacted") || message.includes("liked")) {
      return (
        <div className="notification-icon like-icon">
          <i className="bi bi-hand-thumbs-up-fill"></i>
        </div>
      );
    } else if (message.includes("completed") || message.includes("updated")) {
      return (
        <div className="notification-icon completed-icon">
          <i className="bi bi-check-circle-fill"></i>
        </div>
      );
    } else {
      return (
        <div className="notification-icon default-icon">
          <i className="bi bi-bell-fill"></i>
        </div>
      );
    }
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };
{
  console.log("notificationsnotifications",notifications)
}
  return (
    <>
      {loading ? (
        <div
          className="col-md-12"
          style={{
            height: "40vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="spinner-border spinner-border-sm" role="status"></div>
        </div>
      ) : (
        <>
          {notifications?.length === 0 ? (
            <p className="text-center">No notifications found.</p>
          ) : (
            notifications?.map((item) => (
              <div key={item._id} className="notification-item mb-4">
                <div className="notification-content">
                  <div className="notification-left">
                    {getNotificationIcon(item.message)}
                    <div className="notification-details">
                      <div className="notification-header">
                        <span className="notification-time">
                          {formatTime(item.createdAt)}
                        </span>
                        <span className="online-indicator"></span>
                      </div>
                      <div className="notification-text">
                        <span
                          className="user-name"
                          style={{ paddingRight: "5px" }}
                        >
                          {item.user?.fullName || "Unknown"}
                        </span>
                        <span className="notification-action">
                          {item.message.replace(item.user?.fullName, "").trim()}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="notification-date">
                    {formatDate(item.createdAt)}
                  </div>
                </div>
              </div>
            ))
          )}

          {/* Pagination */}
          {totalPages > 1 && (
            <nav className="d-flex justify-content-center mt-3">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => fetchNotifications(currentPage - 1)}
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <li
                    key={page}
                    className={`page-item ${
                      currentPage === page ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchNotifications(page)}
                    >
                      {page}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => fetchNotifications(currentPage + 1)}
                  >
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </>
      )}
    </>
  );
};

export default PaginatedNotifications;
